import React, { ReactNode } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

type CustomNavLinkPropType = {
    children: ReactNode,
    navPath: string,
    navPathInclude: string,
    isAbsoluteDashboard: boolean
}

const CustomNavLink = ({children, navPath, navPathInclude, isAbsoluteDashboard} : CustomNavLinkPropType) => {
    const location = useLocation();
    const { pathname } = location;

    if (isAbsoluteDashboard) {
        return (
            <NavLink
                to={navPath}
                className={`group relative flex items-center gap-2.5 rounded-sm py-2 px-4 font-medium text-slate-800 duration-300 ease-in-out hover:text-white hover:bg-slate-600 dark:text-white dark:hover:bg-meta-4 ${ pathname === navPathInclude &&
                    'bg-slate-400 dark:bg-meta-4'
                    }`}
                >
                { children }
            </NavLink>
        )
    } else {
        return (
            <NavLink
                to={navPath}
                className={`group relative flex items-center gap-2.5 rounded-sm py-2 px-4 font-medium text-slate-800 duration-300 ease-in-out hover:text-white hover:bg-slate-600 dark:text-white dark:hover:bg-meta-4 ${pathname.includes(navPathInclude) &&
                    'bg-slate-400 dark:bg-meta-4'
                    }`}
                >
                { children }
            </NavLink>
        )        
    }

    
}

export default CustomNavLink;